import { ElectionService, CandidateService } from '../services/firebaseService';
import { Election, Candidate } from '../types';

// Données des élections prédéfinies
const electionsData = [
  {
    title: "Élection du Président",
    position: "Président(e)",
    description: "Élection du Président de l'ASPROCOM",
    candidates: [
      { name: "Grace Monzele", email: "grace.monzele@asprocom.com", bio: "Candidate pour la présidence" }
    ]
  },
  {
    title: "Élection du Vice-président Stratégie",
    position: "Vice-président(e) chargé(e) de la Stratégie",
    description: "Élection du Vice-président chargé de la Stratégie",
    candidates: [
      { name: "Étienne M'libwa", email: "etienne.mlibwa@asprocom.com", bio: "Candidat pour la vice-présidence stratégie" },
      { name: "Melshor Essomassor", email: "melshor.essomassor@asprocom.com", bio: "Candidat pour la vice-présidence stratégie" }
    ]
  },
  {
    title: "Élection du Secrétaire Général",
    position: "Secrétaire Général(e)",
    description: "Élection du Secrétaire Général de l'ASPROCOM",
    candidates: [
      { name: "Djessy Bukasa", email: "djessy.bukasa@asprocom.com", bio: "Candidate pour le secrétariat général" },
      { name: "Shadrack Kalenga", email: "shadrack.kalenga@asprocom.com", bio: "Candidat pour le secrétariat général" }
    ]
  },
  {
    title: "Élection du Trésorier",
    position: "Trésorier(ère)",
    description: "Élection du Trésorier de l'ASPROCOM",
    candidates: [
      { name: "Lynn Mazianda", email: "lynn.mazianda@asprocom.com", bio: "Candidate pour la trésorerie" }
    ]
  },
  {
    title: "Élection Relations Extérieures",
    position: "Chargé(e) des Relations Extérieures et Communication",
    description: "Élection du Chargé des Relations Extérieures et Communication",
    candidates: [
      { name: "Samantha Pascale Kamba", email: "samantha.kamba@asprocom.com", bio: "Candidate pour les relations extérieures" },
      { name: "Yves Kojan", email: "yves.kojan@asprocom.com", bio: "Candidat pour les relations extérieures" }
    ]
  },
  {
    title: "Élection Formation et Développement",
    position: "Chargé(e) de la Formation et du Développement Professionnel",
    description: "Élection du Chargé de la Formation et du Développement Professionnel",
    candidates: [
      { name: "Patrick NSIMBA", email: "patrick.nsimba@asprocom.com", bio: "Candidat pour la formation et le développement" }
    ]
  },
  {
    title: "Élection Événements et Partenariats",
    position: "Chargé(e) des Evénements et Partenariats",
    description: "Élection du Chargé des Evénements et Partenariats",
    candidates: [
      { name: "Joséphine Mawete", email: "josephine.mawete@asprocom.com", bio: "Candidate pour les événements et partenariats" }
    ]
  },
  {
    title: "Élection Vice-président Opérations",
    position: "Vice-président(e) chargé(e) des Opérations",
    description: "Élection du Vice-président chargé des Opérations",
    candidates: [
      // Poste vacant - pas de candidats
    ]
  }
];

export class InitElectionsService {
  
  // Initialiser toutes les élections
  static async initAllElections(): Promise<void> {
    console.log('🚀 Initialisation des élections...');
    
    try {
      for (const electionData of electionsData) {
        // Créer les candidats d'abord
        const createdCandidates = [];
        for (const candidateData of electionData.candidates) {
          const candidate: Omit<Candidate, 'id'> = {
            name: candidateData.name,
            position: electionData.position,
            email: candidateData.email,
            bio: candidateData.bio,
            isActive: true
          };

          const candidateId = await CandidateService.createCandidate(candidate);
          createdCandidates.push({
            id: candidateId,
            name: candidateData.name,
            position: electionData.position,
            email: candidateData.email,
            bio: candidateData.bio,
            isActive: true
          });
          console.log(`  ✅ Candidat créé: ${candidateData.name}`);
        }

        // Créer l'élection avec les candidats
        const election: Omit<Election, 'id'> = {
          title: electionData.title,
          position: electionData.position,
          description: electionData.description,
          startDate: new Date(),
          endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 jours
          isActive: true,
          allowAbstention: true,
          candidates: createdCandidates
        };

        await ElectionService.createElection(election);
        console.log(`✅ Élection créée: ${electionData.title} avec ${createdCandidates.length} candidat(s)`);

        if (electionData.candidates.length === 0) {
          console.log(`  ℹ️ Poste vacant: ${electionData.position}`);
        }
      }

      console.log('✅ Toutes les élections ont été initialisées !');
      
    } catch (error) {
      console.error('❌ Erreur lors de l\'initialisation des élections:', error);
      throw error;
    }
  }

  // Créer une élection spécifique
  static async createSpecificElection(position: string): Promise<void> {
    const electionData = electionsData.find(e => e.position === position);
    
    if (!electionData) {
      throw new Error(`Élection non trouvée pour le poste: ${position}`);
    }

    const election: Omit<Election, 'id'> = {
      title: electionData.title,
      position: electionData.position,
      description: electionData.description,
      startDate: new Date(),
      endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      isActive: true,
      allowAbstention: true,
      candidates: []
    };

      await ElectionService.createElection(election);
      console.log(`✅ Élection créée: ${electionData.title}`);

    // Créer les candidats
    for (const candidateData of electionData.candidates) {
      const candidate: Omit<Candidate, 'id'> = {
        name: candidateData.name,
        position: electionData.position,
        email: candidateData.email,
        bio: candidateData.bio,
        isActive: true
      };

      await CandidateService.createCandidate(candidate);
      console.log(`  ✅ Candidat ajouté: ${candidateData.name}`);
    }
  }
}
